import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export default function Pagination({
  page,
  limit,
  total,
  totalPages,
  onPageChange
}) {
  const { t } = useTranslation();
  
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);
  
  const getPageNumbers = () => {
    const pages = [];
    const showPages = 5;
    
    let startPage = Math.max(1, page - Math.floor(showPages / 2));
    let endPage = Math.min(totalPages, startPage + showPages - 1);
    
    if (endPage - startPage + 1 < showPages) {
      startPage = Math.max(1, endPage - showPages + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };
  
  if (total === 0) return null;
  
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-4 py-3 border-t border-gray-200">
      <div className="text-sm text-gray-500">
        {t('common.showing')} <span className="font-medium">{start}</span> - <span className="font-medium">{end}</span> {t('common.of')} <span className="font-medium">{total}</span> {t('common.results')}
      </div>
      
      <nav className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="p-2 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronLeftIcon className="w-5 h-5 rtl:rotate-180" />
        </button>
        
        {getPageNumbers().map((pageNum) => (
          <button
            key={pageNum}
            onClick={() => onPageChange(pageNum)}
            className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
              pageNum === page
                ? 'bg-primary text-white'
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            {pageNum}
          </button>
        ))}
        
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          className="p-2 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronRightIcon className="w-5 h-5 rtl:rotate-180" />
        </button>
      </nav>
    </div>
  );
}
